import { Card } from '@chakra-ui/react';
import { Form, Formik } from 'formik';
import { useState } from 'react';
import * as Yup from 'yup';

import { PaymentMethod } from '../../../../gql/generated/graphql';
import { FinixPaymentInstrumentToken } from '../../../../utils/types/referrer';
import { customerPersonalInfoValidation } from '../../../../utils/validation/customerInformation';
import { DealWithFarthestState } from '../../utils';
import PayoutAccountDetails from '../PayoutAccountDetails';

const validationSchema = Yup.object({
  ...customerPersonalInfoValidation,
  amount: Yup.number()
    .typeError('Field is required')
    .min(1, 'Must be greater than or equal to $1')
    .max(50_000, 'Must be less than or equal to $50,000')
    .required('Amount is required'),
});

export type PaymentFormValues = {
  first_name: string;
  last_name: string;
  email: string;
  phone_number: string;
  selected_payment_method: PaymentMethod;
  amount: number | null;
};

const PayoutForm = ({
  deal,
  createToken,
  verifyInstrument,
  createMerchant,
  cancelForm,
}: {
  deal: DealWithFarthestState | undefined;
  createToken: (fields: FinixPaymentInstrumentToken) => Promise<{ token?: string; error?: string }>;
  verifyInstrument: (id?: string) => Promise<void>;
  createMerchant: () => Promise<void>;
  cancelForm?: () => void;
}) => {
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  const [finixForm, setFinixForm] = useState<any>(null);

  return (
    <Card
      position="relative"
      borderWidth="1px"
      borderRadius="10px"
      borderColor="gray.100"
      shadow="none"
      border={0}
      px={5}
    >
      <Formik
        enableReinitialize
        validateOnChange={false}
        validateOnBlur={false}
        initialValues={{
          first_name: deal?.customer?.first_name || '',
          last_name: deal?.customer?.last_name || '',
          address_line1: deal?.customer?.address?.address_line || '',
          address_city: deal?.customer?.address?.city || '',
          address_state: deal?.customer?.address?.state || '',
          address_zip: deal?.customer?.address?.zip || '',
          email: deal?.customer?.email || '',
          phone_number: deal?.customer?.phone_number || '',
          selected_payment_method: PaymentMethod.BankAccount,
          amount: null,
        }}
        validationSchema={validationSchema}
        onSubmit={() => {
          return undefined;
        }}
      >
        {({ values }) => (
          <Form>
            <PayoutAccountDetails
              finixForm={finixForm}
              setFinixForm={setFinixForm}
              defaultValues={{
                name: `${values.first_name} ${values.last_name}`,
                address_line1: values.address_line1 || '',
                address_city: values.address_city || '',
                address_state: values.address_state || '',
                address_postal_code: values.address_zip || '',
                address_country: 'USA',
              }}
              createToken={createToken}
              verifyInstrument={verifyInstrument}
              createMerchant={createMerchant}
              cancel={cancelForm}
            />
          </Form>
        )}
      </Formik>
    </Card>
  );
};

export default PayoutForm;
